module.exports = __webpack_public_path__ + "static/img/kbz-965-385-85bb.17a4318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kbz-965-385-85bb.jpg
// module id = SA16
// module chunks = 0